"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var style_1 = __importDefault(require("./style"));
var Scrollbar = /** @class */ (function () {
    function Scrollbar(options, hades, viewport) {
        var _this = this;
        this.wrapper = null;
        this.trackX = { wrapper: null, thumb: null, thumbSize: 0, ratio: 0, drag: false, };
        this.trackY = { wrapper: null, thumb: null, thumbSize: 0, ratio: 0, drag: false, };
        this.options = options;
        this.style = style_1.default;
        this.hades = hades;
        this.viewport = viewport;
        this.drag = false;
        this.detectPositionHandler = function (event) { return _this.detectPosition(event); };
        this.dragStartHandler = function (event) { return _this.dragStart(event); };
        this.dragEndHandler = function (event) { return _this.dragEnd(event); };
        this.init();
    }
    Scrollbar.prototype.init = function () {
        this.appendStyle();
        this.appendDom();
        if (!window.matchMedia('(pointer: coarse) and (hover: none)').matches) {
            this.attachEvents();
        }
    };
    ;
    Scrollbar.prototype.appendDom = function () {
        var _this = this;
        var scrollbar = document.createElement('div');
        scrollbar.classList.add('scrollbar__wrapper');
        this.viewport.append(scrollbar);
        this.options.tracks.forEach(function (track) {
            var wrapper = document.createElement('div');
            wrapper.setAttribute('data-scrollbar', "track-" + track);
            var thumb = document.createElement('div');
            thumb.classList.add('scrollbar__thumb');
            wrapper.append(thumb);
            scrollbar.append(wrapper);
            _this.wrapper = scrollbar;
            if (track === 'x') {
                var thumbSize = thumb.getBoundingClientRect().width;
                _this.trackX = {
                    wrapper: wrapper,
                    thumb: thumb,
                    thumbSize: thumbSize,
                    ratio: 0,
                    drag: false,
                };
            }
            if (track === 'y') {
                var thumbSize = thumb.getBoundingClientRect().height;
                _this.trackY = {
                    wrapper: wrapper,
                    thumb: thumb,
                    thumbSize: thumbSize,
                    ratio: 0,
                    drag: false,
                };
            }
        });
    };
    ;
    Scrollbar.prototype.appendStyle = function () {
        var style = document.createElement('style');
        style.id = 'hades-style';
        style.textContent = this.style;
        if (document.head) {
            document.head.appendChild(style);
        }
    };
    ;
    Scrollbar.prototype.attachEvents = function () {
        if (this.trackX.wrapper !== null && this.trackX.thumb !== null) {
            this.trackX.wrapper.addEventListener('click', this.detectPositionHandler);
            this.trackX.wrapper.addEventListener('mousedown', this.dragStartHandler);
        }
        if (this.trackY.wrapper !== null && this.trackY.thumb !== null) {
            this.trackY.wrapper.addEventListener('click', this.detectPositionHandler);
            this.trackY.wrapper.addEventListener('mousedown', this.dragStartHandler);
        }
    };
    Scrollbar.prototype.listen = function (amount) {
        if (this.trackX.wrapper !== null && this.trackX.thumb !== null) {
            var ratio = amount.x / this.hades.boundries.max.x;
            var width = this.trackX.wrapper.getBoundingClientRect().width;
            var translate = (width - this.trackX.thumbSize) * ratio;
            this.trackX.thumb.style.transform = "translate3d(" + translate + "px, 0, 0)";
            if (ratio === this.trackX.ratio) {
                this.trackX.wrapper.classList.remove('show');
            }
            else {
                this.trackX.wrapper.classList.add('show');
            }
            this.trackX.ratio = ratio;
        }
        if (this.trackY.wrapper !== null && this.trackY.thumb !== null) {
            var ratio = amount.y / this.hades.boundries.max.y;
            var height = this.trackY.wrapper.getBoundingClientRect().height;
            var translate = (height - this.trackY.thumbSize) * ratio;
            this.trackY.thumb.style.transform = "translate3d(0, " + translate + "px, 0)";
            if (ratio === this.trackY.ratio) {
                this.trackY.wrapper.classList.remove('show');
            }
            else {
                this.trackY.wrapper.classList.add('show');
            }
            this.trackY.ratio = ratio;
        }
    };
    ;
    Scrollbar.prototype.detectPosition = function (event) {
        var duration = event.type === 'click' ? 400 : 200;
        if ((event.type === 'click' && event.target.dataset.scrollbar === 'track-y') || (event.type === 'mousemove' && this.drag && this.trackY.drag)) {
            if (this.trackY.wrapper !== null && this.trackY.thumb !== null) {
                var height = this.trackY.wrapper.getBoundingClientRect().height;
                this.hades.scrollTo({
                    y: event.clientY / height * this.hades.boundries.max.y,
                }, duration);
            }
        }
        if ((event.type === 'click' && event.target.dataset.scrollbar === 'track-x') || (event.type === 'mousemove' && this.drag && this.trackX.drag)) {
            if (this.trackX.wrapper !== null && this.trackX.thumb !== null) {
                var width = this.trackX.wrapper.getBoundingClientRect().width;
                this.hades.scrollTo({
                    x: event.clientX / width * this.hades.boundries.max.x,
                }, duration);
            }
        }
    };
    Scrollbar.prototype.dragStart = function (event) {
        this.drag = true;
        if (this.trackY.wrapper !== null && this.trackY.thumb !== null) {
            this.trackY.wrapper.classList.add('show');
            this.trackY.drag = event.target.parentNode.dataset.scrollbar === 'track-y';
        }
        if (this.trackX.wrapper !== null && this.trackX.thumb !== null) {
            this.trackX.wrapper.classList.add('show');
            this.trackX.drag = event.target.parentNode.dataset.scrollbar === 'track-x';
        }
        document.body.addEventListener('mousemove', this.detectPositionHandler);
        document.body.addEventListener('mouseup', this.dragEndHandler);
        document.addEventListener('mouseleave', this.dragEndHandler);
        document.body.addEventListener('mouseleave', this.dragEndHandler);
    };
    Scrollbar.prototype.dragEnd = function (event) {
        this.drag = false;
        if (this.trackY.wrapper !== null && this.trackY.thumb !== null) {
            this.trackY.wrapper.classList.remove('show');
            this.trackY.drag = false;
        }
        if (this.trackX.wrapper !== null && this.trackX.thumb !== null) {
            this.trackX.wrapper.classList.remove('show');
            this.trackX.drag = false;
        }
        document.body.removeEventListener('mousemove', this.detectPositionHandler);
        document.body.removeEventListener('mouseup', this.dragEndHandler);
        document.removeEventListener('mouseleave', this.dragEndHandler);
        document.body.removeEventListener('mouseleave', this.dragEndHandler);
    };
    Scrollbar.prototype.destroy = function () {
        if (this.trackX.wrapper !== null && this.trackX.thumb !== null) {
            this.trackX.wrapper.removeEventListener('click', this.detectPositionHandler);
            this.trackX.wrapper.removeEventListener('mousedown', this.dragStartHandler);
        }
        if (this.trackY.wrapper !== null && this.trackY.thumb !== null) {
            this.trackY.wrapper.removeEventListener('click', this.detectPositionHandler);
            this.trackY.wrapper.removeEventListener('mousedown', this.dragStartHandler);
        }
        document.body.removeEventListener('mousemove', this.detectPositionHandler);
        document.body.removeEventListener('mouseup', this.dragEndHandler);
        document.removeEventListener('mouseleave', this.dragEndHandler);
        document.body.removeEventListener('mouseleave', this.dragEndHandler);
        var style = document.getElementById('hades-style');
        if (!style || !style.parentNode) {
            return;
        }
        style.parentNode.removeChild(style);
        if (this.wrapper !== null)
            this.wrapper.remove();
    };
    return Scrollbar;
}());
exports.default = Scrollbar;
